import { from as observableFrom, Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { companyMortgageCommand } from '../../command/company-mortgage.command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { CompanyMortgage } from '../../model/company-mortgage';
import { map } from 'rxjs/operators';
import { AddAmortizationComponent } from '../../component/add-amortization/add-amortization.component';

@Injectable()
export class AddAmortizationCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === companyMortgageCommand.addAmortization && command.context;
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      return this._actionService.open(AddAmortizationComponent, this._injector, null, command.context).pipe(
        map(result => {
          if (command.context instanceof CompanyMortgage) {
            command.context.balance = result.balance;
            return true;
          }
          return false;
        })
      );
    }
  }
}
